import { type FC } from 'react'

import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { ProductAddToCartQuantitySelection } from '../../../product-page/components/ProductBuyBox/ProductAddToCartGroup/ProductAddToCartQuantitySelection/ProductAddToCartQuantitySelection'

import { ExperimentStickyBuyBoxCta } from './ExperimentStickyBuyBoxCta'
import { ExperimentStickyBuyBoxPriceInfo } from './ExperimentStickyBuyBoxPriceInfo'
import { ExperimentStickyBuyBoxProductQuantity } from './ExperimentStickyBuyBoxProductQuantity'

export const ExperimentStickyBuyBoxV1: FC<{
  disableCta: boolean
  product: PimProductV11
}> = ({ disableCta, product }) => (
  <div className="fixed inset-x-0 bottom-0 z-10 hidden border-t border-dark-primary-min bg-light-primary-low p-3.5 tablet:flex">
    <ul className="container mx-auto flex justify-between">
      <li>
        <h2 className="text-m font-medium">{product.name}</h2>
        <ExperimentStickyBuyBoxProductQuantity />
      </li>
      <li>
        <ProductAddToCartQuantitySelection className="ml-5 w-[108px] shrink-0" />
      </li>
      <li className="grow">
        <ExperimentStickyBuyBoxPriceInfo showPricePerUnit />
      </li>
      <li>
        <ExperimentStickyBuyBoxCta disableCta={disableCta} />
      </li>
    </ul>
  </div>
)
